module.exports = __webpack_public_path__ + "media/taxons/money-blue-7cfae17e.png";